module.exports = __webpack_public_path__ + "media/images/pic/meat-board-dfea44822c30cbada704fa61fffe1c19.jpg";